export enum SoloHeroShapeStyle {
  Default = 'default',
  FullRound = 'round',
  WithAngle = 'angle',
  lion = 'lion',
}
